<style scoped lang="scss" type="text/scss">
.wrap-container {}
</style>

<template>
  <div class="wrap-container global-relative">
    <div class="global-relative">
      <loading-placeholder :loading="requesting"></loading-placeholder>
      <el-table :data="players" stripe border size="small" style="width: 100%; margin-top: 1rem"
        :max-height="visualAreaHeight">
        <el-table-column fixed prop="iz_select" label="中期" align="center" min-width="150">
          <template slot-scope="scope">
             不通过<el-switch
              v-model="scope.row.iz_select"
              @change="checkboxChange($event, scope.row.id)"
              active-color="#13ce66"
              inactive-color="#ff4949">
          </el-switch>通过
          </template>
        </el-table-column>

        <el-table-column fixed type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column fixed prop="school_name" label="学校名称" align="center" min-width="80"></el-table-column>
        <el-table-column fixed prop="team_name" label="队伍名称" align="center" min-width="80"></el-table-column>
        <el-table-column prop="middle_check_photo01_url" label="图片一" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo01_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo01_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo02_url" label="图片二" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo02_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo02_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo03_url" label="图片三" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo03_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo03_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo04_url" label="图片四" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo04_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo04_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>

          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo05_url" label="图片五" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo05_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo05_url)" ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo06_url" label="图片六" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo06_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo06_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_photo07_url" label="图片七" align="center" min-width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.middle_check_photo07_url + '?x-oss-process=image/resize,w_200'" style="width: 100%; height: 100px"
              :preview-src-list="srcList" @click="changeimage(scope.row, scope.row.middle_check_photo07_url)"
              ref="elImage">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_video01_url" label="机器人视频" align="center" min-width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.middle_check_video01_url" :href="scope.row.middle_check_video01_url" target="_blank">
              预览
            </a>
          </template>
        </el-table-column>

        <el-table-column prop="middle_check_doc01_url" label="其他-文档" align="center" min-width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.middle_check_doc01_url" :href="scope.row.middle_check_doc01_url" target="_blank">
              预览
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="middle_check_video02_url" label="其他-视频" align="center" min-width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.middle_check_video02_url" :href="scope.row.middle_check_video02_url" target="_blank">
              预览
            </a>
          </template>
        </el-table-column>

        <el-table-column prop="middle_check_doc02_url" label="其他-压缩包" align="center" min-width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.middle_check_doc02_url" :href="scope.row.middle_check_doc02_url" target="_blank">
              下载
            </a>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
import infoPanel from '../../../../../components/info-panel/index';
import StatusTag from '../../../../../components/status-tag/index';
import { handlePlayers } from '../../../../../utils/data-handler';

export default {
  name: '',
  components: {
    infoPanel,
    StatusTag
  },
  data() {
    return {
      requesting: false,
      players: [],
      cancelConfirmationRequestingId: null,
      cancelConfirmationRequesting: false,
      srcList: []
    };
  },
  computed: {
    currentCompetitionId() {
      return this.$store.state.competition.currentCompetitionId;
    },
    visualAreaHeight() {
      return this.$store.getters['layout/adminPlayerInformationOverviewVisualAreaHeight'];
    }
  },
  watch: {
    currentCompetitionId: {
      immediate: true,
      handler(id) {
        if (id === null || id === undefined) return;
        this.loadPlayersWithOverviewByCompetitionId();
      }
    }
  },
  methods: {
    changeimage(row, url) {
      this.srcList = []
      if (row.middle_check_photo01_url != null) {
        this.srcList.push(row.middle_check_photo01_url);
      }
      if (row.middle_check_photo02_url != null) {
        this.srcList.push(row.middle_check_photo02_url);
      }
      if (row.middle_check_photo03_url != null) {
        this.srcList.push(row.middle_check_photo03_url);
      }
      if (row.middle_check_photo04_url != null) {
        this.srcList.push(row.middle_check_photo04_url);
      }
      if (row.middle_check_photo05_url != null) {
        this.srcList.push(row.middle_check_photo05_url);
      }
      if (row.middle_check_photo06_url != null) {
        this.srcList.push(row.middle_check_photo06_url);
      }
      if (row.middle_check_photo07_url != null) {
        this.srcList.push(row.middle_check_photo07_url);
      }
      this.$nextTick(() => {
        // this.$refs.elImage.clickHandler() //触发el-image组件
        setTimeout(() => {
          let that = this
          let index = 0
          let next = document.querySelector('.el-image-viewer__next'); //下一页
          let prev = document.querySelector('.el-image-viewer__prev'); //上一页
          index = this.srcList.indexOf(url);
          if (index == 0) {
            prev.style.display = 'none'
          }
          if (index == this.srcList.length - 1) {
            next.style.display = 'none'
          }
          next.onclick = function pre() { //下一张
            index = index + 1
            // console.log('下一张', index, that.srcList.length);
            if (index == that.srcList.length - 1) {
              next.style.display = 'none'
              prev.style.display = 'block'
            } else {
              prev.style.display = 'block'
              next.style.display = 'block'
            }
            // console.log("that.$refs.elImage.$children[0]", that.$refs.elImage)
            setTimeout(() => {
            }, 10)
          }
          prev.onclick = function nexts() { //上一张
            index = index - 1
            // console.log('上一张', index);
            if (index == 0) {
              // console.log('上一个消失');
              prev.style.display = 'none'
              next.style.display = 'block'
            } else {
              prev.style.display = 'block'
              next.style.display = 'block'
            }
            setTimeout(() => {
            }, 10)
          }
          next.addEventListener("click", function () {
          });
          prev.addEventListener("click", function () {
          });
        }, 50)
      })
    },
    filterTag(value, row) {
      var isShow = value === '已确认'
      return row.confirmed_boolean === isShow;
    },
    loadPlayersWithOverviewByCompetitionId() {
      this.$normalRequest('player/loadPlayersWithMiddleCheckByCompetitionId', {
        competition_id: this.currentCompetitionId
      }, false, false, this, 'requesting').then(data => {
        this.players = handlePlayers(data);
        // console.log(this.players)

      });
    },
  }
};
</script>
